import InfoCard from '@innovyze/stylovyze/lib/components/InfoCard';
import StatusTag from '@innovyze/stylovyze/lib/components/StatusTag';
import React from 'react';
import { Divider, Layout, ProgressTag, Prop, PropTitle, Tag, } from './PropertyCard.styles';
import { AlertType, RiskType, StatusType } from './types';
import { CurrencyDisplay } from '@innovyze/stylovyze/lib/components/CurrencyDisplay';
import { TextOverflow } from '@innovyze/stylovyze/lib/components/TextOverflow';
import UnitDisplay from '@innovyze/stylovyze/lib/components/UnitDisplay';
import { useGlobalization } from '@innovyze/stylovyze/lib/contexts/GlobalizationProvider';
import { toDecimalPlaces } from '@innovyze/stylovyze/lib/utils/unitConversion';
import { Skeleton } from '@mui/material';
import { useCompanyDateTime, useTzDateTime } from '../DateTimeInput';
export const PropertyCard = ({ title, properties, menuItems, columns = 1, forceMenu = true, additionalContent, ...other }) => {
    const { t } = useGlobalization();
    const { formatDate } = useCompanyDateTime();
    const formatDateUTC = useTzDateTime({ timeZone: 'UTC' }).formatDate;
    const getStatus = (value) => {
        switch (value) {
            case StatusType.complete:
                return t('Complete');
            case StatusType.failed:
                return t('Failed');
            case StatusType.inProgress:
                return t('In Progress');
            case StatusType.cancelled:
                return t('Cancelled');
        }
    };
    const getAlert = (value) => {
        switch (value) {
            case AlertType.high:
                return t('High');
            case AlertType.low:
                return t('Low');
            case AlertType.info:
                return t('Informative');
        }
    };
    return (React.createElement(InfoCard, { title: title, menuItems: menuItems, forceMenu: forceMenu, ...other },
        React.createElement(Layout, { columns: columns, contentAfter: !!additionalContent }, properties.map(({ title: propTitle, value, type, cy, span, ellipsis, divideAfter, loading, decimalPlaces, currency, }, k) => (React.createElement(Prop, { key: k, span: span },
            loading && (React.createElement(React.Fragment, null,
                React.createElement(PropTitle, null, propTitle),
                React.createElement(Skeleton, { animation: "wave" }))),
            !loading && (React.createElement(React.Fragment, null,
                React.createElement(PropTitle, null, propTitle),
                type === 'risk' &&
                    (RiskType[value] ? (React.createElement(StatusTag, { color: RiskType[value], text: RiskType[value] })) : ('-')),
                type === 'status' && (React.createElement(ProgressTag, { status: value, "data-cy": cy }, getStatus(value))),
                type === 'priority' && (React.createElement(Tag, { status: value, "data-cy": cy }, getAlert(value))),
                type === 'date' && (React.createElement("div", { "data-cy": cy }, value
                    ? formatDate({
                        date: value,
                        format: 'date-time',
                    })
                    : '-')),
                type === 'dateonly' && (React.createElement("div", { "data-cy": cy }, value
                    ? formatDate({
                        date: value,
                        format: 'date',
                    })
                    : '-')),
                type === 'dateUTC' && (React.createElement("div", { "data-cy": cy }, value
                    ? formatDateUTC({
                        date: value,
                        format: 'date-time',
                    })
                    : '-')),
                type === 'dateonlyUTC' && (React.createElement("div", { "data-cy": cy }, value
                    ? formatDateUTC({
                        date: value,
                        format: 'date',
                    })
                    : '-')),
                type === 'unit' &&
                    (value ? (React.createElement(UnitDisplay, { value: value, cy: cy, decimalPlaces: decimalPlaces })) : ('-')),
                type === 'currency' &&
                    (value ? (React.createElement(CurrencyDisplay, { value: value, cy: cy, precision: decimalPlaces, currency: currency })) : ('-')),
                type === 'number' && (React.createElement("div", { "data-cy": cy }, (value &&
                    toDecimalPlaces(value, decimalPlaces)) ??
                    '-')),
                type === 'boolean' && (React.createElement("div", { "data-cy": cy }, value === true
                    ? t('True', {
                        context: 'Boolean value',
                    })
                    : value === false
                        ? t('False', {
                            context: 'Boolean value',
                        })
                        : '-')),
                (type === 'text' || !type) && (React.createElement("div", { "data-cy": cy }, ellipsis ? (React.createElement(TextOverflow, null, value ?? '-')) : (value ?? '-'))))),
            divideAfter && React.createElement(Divider, { span: columns }))))),
        additionalContent));
};
export default React.memo(PropertyCard);
